module.exports = __webpack_public_path__ + "img/block-1920.b0f6f8b0.jpg";